"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.togglePropTypes = exports["default"] = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _automationHooks = require("@airportlabs/automation-hooks");
var _ScreenReaderText = _interopRequireDefault(require("../Typography/ScreenReaderText"));
var _helpers = require("../helpers");
var _excluded = ["value", "name", "id", "checked", "readerLabel", "colorOn", "colorOff", "fieldsAligned", "size", "automationHook"];
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var togglePropTypes = {
  /**
   * Name for the input field
   */
  name: _propTypes["default"].string,
  /**
   * Value for the field; in our case can also be a boolean since we are also using toggles true/false fields
   */
  value: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].bool]),
  /**
   * Id for the checkbox field
   */
  id: _propTypes["default"].string,
  /**
   * Weather or not the checkbox is checked
   */
  checked: _propTypes["default"].bool,
  /**
   * Label used for screen reader in the form "label" on / off
   */
  readerLabel: _propTypes["default"].string,
  /**
   * A valid color name used for background when the toggle is "on"
   */
  colorOn: _propTypes["default"].string,
  /**
   * A valid color name used for background when the toggle is "off"
   */
  colorOff: _propTypes["default"].string,
  /** When `true` it wraps the toggle in a wrapper that has the height of an input and aligns the toggle vertically in the center */
  fieldsAligned: _propTypes["default"].bool,
  /** Control the Toggle size */
  size: _propTypes["default"].oneOf(["small", "default"]),
  /**
   * Used for automation testing
   * Will append the `toggle/toggle-checked` suffix
   */
  automationHook: _propTypes["default"].string
};
exports.togglePropTypes = togglePropTypes;
var tglSizeSmall = "12px";
var tglPaddingSmall = "2px";
var tglExtraWidthSmall = "3px";
var tglTranslateSmall = "15px"; // tglSize + tglExtraWidth

var tglSize = "16px";
var tglPadding = "2px";
var tglExtraWidth = "3px";
var tglTranslate = "19px";
var Handle = _styledComponents["default"].div.withConfig({
  displayName: "Toggle__Handle",
  componentId: "sc-zd6ma-0"
})(["display:block;height:", ";width:", ";border-radius:50%;background:white;top:", ";left:", ";position:absolute;transform:translateX(0);transition:all 0.2s ease;", ""], tglSize, tglSize, tglPadding, tglPadding, function (props) {
  return props.size && props.size === "small" && (0, _styledComponents.css)(["height:", ";width:", ";top:", ";left:", ";box-shadow:0 0 4px 0 rgba(0,0,0,0.2);"], tglSizeSmall, tglSizeSmall, tglPaddingSmall, tglPaddingSmall);
});
var Container = _styledComponents["default"].label.withConfig({
  displayName: "Toggle__Container",
  componentId: "sc-zd6ma-1"
})(["position:relative;display:block;cursor:pointer;height:calc(", " + 2 * ", ");width:calc(2 * ", " + 2 * ", " + ", ");border-radius:", ";background-color:", ";input:checked ~ &{background-color:", ";}", ""], tglSize, tglPadding, tglSize, tglPadding, tglExtraWidth, tglSize, function (props) {
  return (0, _helpers.getColor)(props, "colorOff", props.theme.toggles.colorOff);
}, function (props) {
  return (0, _helpers.getColor)(props, "colorOn", props.theme.toggles.colorOn);
}, function (props) {
  return props.size && props.size === "small" && (0, _styledComponents.css)(["height:calc(", " + 2 * ", ");width:calc( 2 * ", " + 2 * ", " + ", " );border-radius:", ";"], tglSizeSmall, tglPaddingSmall, tglSizeSmall, tglPaddingSmall, tglExtraWidthSmall, tglSizeSmall);
});
var Wrapper = _styledComponents["default"].div.withConfig({
  displayName: "Toggle__Wrapper",
  componentId: "sc-zd6ma-2"
})(["position:relative;display:inline-block;", ";input[type=\"checkbox\"]{outline:none;visibility:hidden;position:absolute;left:-9999px;}input:checked ~ ", "{transition:all 0.2s ease;", "{transform:translateX(", ");transition:all 0.2s ease;}", "}input:disabled ~ ", "{opacity:0.8;cursor:not-allowed;}", ""], function (props) {
  return props.full && (0, _styledComponents.css)(["display:block;width:100%;"]);
}, Container, Handle, tglTranslate, function (props) {
  return props.size && props.size === "small" && (0, _styledComponents.css)(["", "{transform:translateX(", ");}"], Handle, tglTranslateSmall);
}, Container, function (props) {
  return props.fieldsAligned && (0, _styledComponents.css)(["height:", ";display:flex;align-items:center;"], props.theme.fields.height);
});
var Toggle = function Toggle(_ref) {
  var value = _ref.value,
    name = _ref.name,
    id = _ref.id,
    checked = _ref.checked,
    readerLabel = _ref.readerLabel,
    colorOn = _ref.colorOn,
    colorOff = _ref.colorOff,
    fieldsAligned = _ref.fieldsAligned,
    size = _ref.size,
    automationHook = _ref.automationHook,
    rest = _objectWithoutProperties(_ref, _excluded);
  var theme = (0, _styledComponents.useTheme)();
  size = size || theme.toggles.size;
  return /*#__PURE__*/_react["default"].createElement(Wrapper, _extends({
    fieldsAligned: fieldsAligned,
    size: size
  }, (0, _automationHooks.hook)(automationHook, checked ? "toggle-checked" : "toggle")), /*#__PURE__*/_react["default"].createElement("input", _extends({
    type: "checkbox",
    id: id || "".concat(name, "_").concat(value),
    value: value,
    checked: checked
  }, rest)), /*#__PURE__*/_react["default"].createElement(Container, {
    htmlFor: id || "".concat(name, "_").concat(value),
    colorOn: colorOn,
    colorOff: colorOff,
    size: size
  }, /*#__PURE__*/_react["default"].createElement(Handle, {
    size: size
  }), /*#__PURE__*/_react["default"].createElement(_ScreenReaderText["default"], null, readerLabel, " ", checked ? "On" : "Off")));
};
Toggle.propTypes = togglePropTypes;
var _default = Toggle;
exports["default"] = _default;